import actionTypes from 'SRC/modules/redux/actionTypes'

export const setRegistrationPremiumClasses = registrationPremiumClasses => {
  return {
    type: actionTypes.SET_REGISTRATION_PREMIUM_CLASSES,
    payload: registrationPremiumClasses
  }
}
